var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsDateString, IsEmail, IsOptional, IsString, IsUUID, MaxLength, } from 'class-validator';
export class CreatePatientByAdminDto {
    // Optional: a credential-less (practice-managed) patient is created without an
    // email (TM-9118). When present it is still validated as an email.
    email;
    firstName;
    lastName;
    agreedConsentfile;
    officeLocationId;
    therapistId;
    // Optional billing address. A practice-managed patient never logs in, so the
    // practice is the only party that can supply the address invoice issuance
    // requires. Captured here so the patient is billable without a later edit.
    street;
    zip;
    town;
    // The rest of the patient's data, optional like the address: the create column
    // shows the same fields as the patient file, so whatever is known at the desk is
    // entered once instead of in a second visit to the file.
    salutation;
    /** `YYYY-MM-DD`. */
    birthdate;
    mobilePhone;
    krankenkasse;
}
__decorate([
    IsOptional(),
    IsEmail(),
    Expose(),
    __metadata("design:type", String)
], CreatePatientByAdminDto.prototype, "email", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    Expose(),
    __metadata("design:type", String)
], CreatePatientByAdminDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    Expose(),
    __metadata("design:type", String)
], CreatePatientByAdminDto.prototype, "lastName", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], CreatePatientByAdminDto.prototype, "agreedConsentfile", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], CreatePatientByAdminDto.prototype, "officeLocationId", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], CreatePatientByAdminDto.prototype, "therapistId", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    Expose(),
    __metadata("design:type", String)
], CreatePatientByAdminDto.prototype, "street", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    Expose(),
    __metadata("design:type", String)
], CreatePatientByAdminDto.prototype, "zip", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    Expose(),
    __metadata("design:type", String)
], CreatePatientByAdminDto.prototype, "town", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    Expose(),
    __metadata("design:type", String)
], CreatePatientByAdminDto.prototype, "salutation", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    Expose(),
    __metadata("design:type", String)
], CreatePatientByAdminDto.prototype, "birthdate", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    Expose(),
    __metadata("design:type", String)
], CreatePatientByAdminDto.prototype, "mobilePhone", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    Expose(),
    __metadata("design:type", String)
], CreatePatientByAdminDto.prototype, "krankenkasse", void 0);
//# sourceMappingURL=create-patient-by-admin.dto.js.map